import styled from 'styled-components';
import {whiteClock} from '../../assets/symbols/symbols/Symbols.css';
import {BGImageCenter, WHITE, dFlexCenter, ellipsisLines, mobileMedia, tabletMedia, tabletScreen} from '../../globalVariables/GlobalVariables';
import zIndex from '../../globalVariables/zIndex';
import {container} from '../../component/customScrollbar/CustomScrollbar.css';
import {wideScreen} from '../../globalVariables/GlobalVariables';

export const control=styled.div`
    border-radius:30px ;
    padding-inline-start: ${p=>p.theme.mini?'10':'25'}px;
    padding-inline-end: ${p=>p.theme.mini?'10':'15'}px;
    width: max-content;
    height: 22px;
    ${p=>(!p.theme.realtime || !p.theme.mini) && 'border-top: 1px solid #696969'};
     color:#FFFFFF ;
     font-size:12px ;
     cursor: pointer;
     position: relative;
     ${dFlexCenter};
     margin:5px auto;
     margin-top: ${p=>p.theme.mini?30:5}px;
     &::before{
        content:'';
        display:  ${p=>p.theme.mini?'none':'block'};
        width:15px;
        height: 15px;
        position: absolute;    
        ${BGImageCenter(whiteClock,'contain')};
        inset-inline-start:3px;
     }
     ${mobileMedia}{
        margin:7px auto ;
  }
`;
const smallDisplay = `
    height: 96%;
    inset-block-start: 2%;
    inset-inline-start: 20px;
    z-index: ${zIndex.baseHigh};
`;
export const EventMenu=styled.div`
    height: 100%;
    @media screen and (min-width:${tabletScreen}px){
        ${p=>p.theme.realtime && smallDisplay}
    }
    @media screen and (min-width:${tabletScreen}px) and (max-width:${wideScreen}px){
        ${p=>p.theme.subscriptions && smallDisplay}
    }
    transition:all 200ms;
    width:${props=>props.theme.mini?'65':'230'}px;
    @media screen and (max-width: 1000px){
    height:calc(100% - 50px);
       width:100%;
    }
    position: relative;
`;
const topHeight = p=>p.theme.realtime && p.theme.mini ? '200px' : '150px';

export const EventMenuTopBack=styled.div` 
    ${p=>BGImageCenter(p.img,'cover')}
    height:${topHeight};
    position:relative;
    border-radius: ${p=>p.theme.rtl?'10px 0 0 10px':'0 10px 10px 0'};
    border-radius: ${p=>p.theme.realtime && '10px 10px 0 0'};
    overflow:hidden;
    &::after{
        content:'';
        backdrop-filter: brightness(0.6) blur(10px);
         -webkit-backdrop-filter: brightness(0.6) blur(10px);
         width:100%;
         height:100%;
         top:0;
         left:0;
         position:absolute;
        background-image: linear-gradient(#ffffff47, #000);
    }
    ${tabletMedia}{
        height:100px;
    } 
`;

export const wrapStats=styled.div` 
  height:180px ;
  width:100% ;
  background-color:#000000 ;
  border-radius: ${p=>p.theme.rtl?'10px 0 0 10px':'0 10px 10px 0'}; 
  margin-top:3px ;
  ${dFlexCenter};
  flex-direction: column;
  ${tabletMedia}{
    height: 140px;
  }
`;

export const bottomMenu=styled.div` 
    position:relative;
    height:calc(100% - ${topHeight}) ;
    border-radius:${p=>p.theme.rtl?'10px 0 0 10px':'0 10px 10px 0'}; 
    border-radius:${p=>p.theme.realtime && '0 0 10px 10px'};
    background:#363636;
    ${tabletMedia}{
        height:calc(100% - 100px) ;
  }
    ${container}{
        ${mobileMedia}{
            display: none;
        }
        opacity: 0;
        transition: opacity 0.3s;
    }
    &:hover ${container} {
        opacity: 1;
    }
`;
export const EventMenuTop=styled.div`
        position:relative;
         height:100%;
         width:100%;
         z-index:${zIndex.baseRaised};
         ${p=>p.theme.realtime && 'background:#363636'};
`;
export const headTop=styled.div`
        z-index:${zIndex.baseHigh};
        position:relative;
        height:100%;
        width:100%;
     @media screen and (max-width: 1000px){
        padding:20px 40px;
     }
`;
export const EMTitleFrame=styled.div`
     @media screen and (max-width: 1000px){
         display:flex;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        height: 47px;
         padding: 0 25px;
         flex-direction: column;
     }
`;
export const EMTitleLeft=styled.div`
     @media screen and (max-width: 1000px){
       
     }
`;
export const EventMenuHead=styled.div`
    height:45px;
    display:flex;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
     @media screen and (max-width: 1000px){
        height: 30px;
        padding-inline-end: 15px;
        justify-content: flex-end;
     }
`;
export const EMHeadMini=styled.div`
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='2047 -335.615 43.536 37.615'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: %23fff; %7D .cls-2 %7B fill: %23fff; %7D %3C/style%3E%3C/defs%3E%3Cg id='Group_10' data-name='Group 10' transform='translate(1985 -387)'%3E%3Crect id='Rectangle_2' data-name='Rectangle 2' class='cls-1' width='43.536' height='9.449' rx='4.724' transform='translate(62 51.385)'/%3E%3Crect id='Rectangle_3' data-name='Rectangle 3' class='cls-2' width='43.536' height='9.449' rx='4.724' transform='translate(62 65.468)'/%3E%3Crect id='Rectangle_4' data-name='Rectangle 4' class='cls-1' width='43.536' height='9.449' rx='4.724' transform='translate(62 79.551)'/%3E%3C/g%3E%3C/svg%3E");
           background-repeat: no-repeat;
           background-size: 17px 17px;
           background-position: center center;
           width: 65px;
           cursor:pointer;
           
`;
export const EMHeadType=styled.div`    
    width: calc(100% - 85px);
    text-align: left;
    display:  ${props=>props.theme.mini?'none':'-webkit-box'};
    display:  ${props=>props.theme.mini?'none':'-webkit-flex'};
    display: ${props=>props.theme.mini?'none':'-ms-flexbox'};
    display: ${props=>props.theme.mini?'none':'flex'} ;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #fff;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    font-size: 14px;
     @media screen and (max-width: 1000px){
            width: max-content;
            font-size: 12px;
        }
`;
export const EventMenuTitle=styled.div`
    height: 55px;
    font-size: ${props=>props.theme.mini?'14':'24'}px;
    color: #fff;
    font-weight: 700;
    text-align: center;
    line-height: ${props=>props.theme.mini?'13':'26'}px;
    overflow: hidden;
    margin: 0 10px; 
    ${ellipsisLines(2)}
     text-shadow: 0px 0px 4px #000000BE;
    @media screen and (max-width: 1000px){
        margin: 0;
        font-size: 22px;
        width: 100%;
    }
`;
export const EventMenuDate=styled.div`
    height: 30px;
    text-align: center;
    font-size: 12px;
    line-height: 13px;
    color: #fff;
    span{
        height: 5px;
        width: 5px;
        border-radius: 50%;
    }
    @media screen and (max-width: 1000px){
        height:18px;
        letter-spacing:${props=>props.theme.rtl?'0.8':'1.6'}px;
        font-size: 10px;
        line-height: 18px;
    }
`;
export const EventMenuBot=styled.div`
    ${p=>(!p.theme.realtime || !p.theme.mini) && 'border-top: 1px solid #696969'};
    >div{
        color: #fff;
        height: 50px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        position: relative;
        ${props => props.theme.mini && 'height: 70px; flex-direction: column;'};
    }
    @media screen and (max-width: 1000px){
        height: 100px;
    }
`;
const item = {
    'lang':"data:image/svg+xml,%3Csvg id='Group_591' data-name='Group 591' xmlns='http://www.w3.org/2000/svg' width='26.281' height='25.354' viewBox='0 0 26.281 25.354'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: %23fff; %7D %3C/style%3E%3C/defs%3E%3Cg id='Group_574' data-name='Group 574' transform='translate(0 7.266)'%3E%3Cpath id='Path_718' data-name='Path 718' class='cls-1' d='M2.937,22.788H2.628a.85.85,0,0,1-.464-.773V19.077H1.855A1.88,1.88,0,0,1,0,17.222V5.937A1.219,1.219,0,0,1,1.237,4.7h13.3a1.33,1.33,0,0,1,1.237,1.237V17.222a1.786,1.786,0,0,1-1.855,1.855h-6.8L3.556,22.633A.929.929,0,0,1,2.937,22.788ZM1.7,6.246V17.068a.333.333,0,0,0,.309.309H3.092a.73.73,0,0,1,.773.773V20l2.319-2.319a.8.8,0,0,1,.618-.309h7.111a.333.333,0,0,0,.309-.309V6.246H1.7Z' transform='translate(0 -4.7)'/%3E%3C/g%3E%3Cg id='Group_575' data-name='Group 575' transform='translate(10.513)'%3E%3Cpath id='Path_719' data-name='Path 719' class='cls-1' d='M19.631,18.242a1.172,1.172,0,0,1-.618-.309L15.3,14.377H12.984v-1.7h2.783a1.172,1.172,0,0,1,.618.309l2.474,2.474V13.6a.73.73,0,0,1,.773-.773h1.082a.333.333,0,0,0,.309-.309V1.7H8.655V6.493H6.8V1.546C6.8.155,7.573,0,8.346,0H21.177a1.386,1.386,0,0,1,1.391,1.391V12.522a1.786,1.786,0,0,1-1.855,1.855H20.4v2.937a.85.85,0,0,1-.464.773C19.786,18.088,19.786,18.242,19.631,18.242Z' transform='translate(-6.8 0)'/%3E%3C/g%3E%3Cg id='Group_576' data-name='Group 576' transform='translate(5.041 10.358)'%3E%3Cpath id='Path_720' data-name='Path 720' class='cls-1' d='M6.877,7.009c0-.155-.155-.309-.464-.309-.155,0-.309.155-.464.309L3.321,14.121c-.155.155,0,.464.309.618.155.155.464,0,.618-.309l.618-1.546h3.4l.618,1.546c0,.155.309.309.464.309h.155a.8.8,0,0,0,.309-.618ZM5.022,11.956,6.413,8.4,7.8,11.956Z' transform='translate(-3.261 -6.7)'/%3E%3C/g%3E%3Cg id='Group_577' data-name='Group 577' transform='translate(15.305 3.092)'%3E%3Cpath id='Path_721' data-name='Path 721' class='cls-1' d='M11.446,9.575v.309a8.781,8.781,0,0,0,2.164-1.7,11.412,11.412,0,0,0,2.474,1.855h.155c.155,0,.309,0,.309-.155.155-.155,0-.464-.155-.618-.928-.618-1.7-1.237-2.319-1.7A6.276,6.276,0,0,0,15.62,4.01h.928a.41.41,0,0,0,.464-.464.41.41,0,0,0-.464-.464H13.919V2.464a.464.464,0,1,0-.928,0v.464H10.364a.41.41,0,0,0-.464.464.41.41,0,0,0,.464.464h4.329A4.811,4.811,0,0,1,13.3,6.792a6.513,6.513,0,0,1-1.082-2.01H11.6a7.72,7.72,0,0,0,1.391,2.783,16.43,16.43,0,0,1-1.7,1.391C11.446,9.111,11.446,9.266,11.446,9.575Z' transform='translate(-9.9 -2)'/%3E%3C/g%3E%3C/svg%3E%0A",
    'def':"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='1579.947 2442 28.03 28.154'%3E%3Cdefs%3E%3Cstyle%3E.cls-1 %7Bfill: %23fff;%7D%3C/style%3E%3C/defs%3E%3Cpath id='Path_10' data-name='Path 10' class='cls-1' d='M26.747,10.744H24.053c-.064-.259-.192-.518-.257-.777V9.9l-.385-.777,1.86-1.877h0a1.14,1.14,0,0,0,0-1.618L22.257,2.589h0a1.116,1.116,0,0,0-1.6,0L18.729,4.531l-.77-.388c-.257-.129-.513-.194-.834-.324V1.165A1.155,1.155,0,0,0,15.971,0h-4.3a1.155,1.155,0,0,0-1.155,1.165V3.883a4.429,4.429,0,0,0-.834.324,3.689,3.689,0,0,1-.577.324L7.248,2.654l-.064-.065a1.116,1.116,0,0,0-1.6,0L2.566,5.631h0a1.14,1.14,0,0,0,0,1.618L4.49,9.191a3.484,3.484,0,0,0-.321.712l-.064.065c-.128.259-.192.518-.321.777H1.155A1.155,1.155,0,0,0,0,11.909v4.336A1.155,1.155,0,0,0,1.155,17.41H3.849c.064.259.192.518.257.712v.065l.385.777L2.63,20.841H2.566a1.14,1.14,0,0,0,0,1.618L5.58,25.5h.064a1.116,1.116,0,0,0,1.6,0l1.924-1.942a3.423,3.423,0,0,0,.706.324l.064.065c.257.129.513.194.834.324v2.718a1.155,1.155,0,0,0,1.155,1.165h4.3a1.155,1.155,0,0,0,1.155-1.165V24.271a4.429,4.429,0,0,0,.834-.324l.77-.388,1.86,1.877h0a1.116,1.116,0,0,0,1.6,0l3.015-3.042h0a1.14,1.14,0,0,0,0-1.618L23.54,18.834l.385-.777a3.672,3.672,0,0,0,.257-.777h2.694a1.155,1.155,0,0,0,1.155-1.165V11.78a1.384,1.384,0,0,0-1.283-1.036ZM25.593,15.08H23.219a1.235,1.235,0,0,0-1.155.971c-.128.453-.257.841-.385,1.23a7.4,7.4,0,0,1-.641,1.23,1.178,1.178,0,0,0,.128,1.424h0L22.9,21.682l-1.411,1.424-1.732-1.748a1.157,1.157,0,0,0-1.475-.129,4.84,4.84,0,0,1-1.155.583,10.985,10.985,0,0,1-1.347.453,1.166,1.166,0,0,0-.9,1.1v2.459H12.893V23.365a1.115,1.115,0,0,0-.962-1.1c-.449-.129-.834-.259-1.283-.388h-.064a4.912,4.912,0,0,1-1.155-.647,1.162,1.162,0,0,0-1.411.194h0l-1.6,1.683L4.939,21.682l1.732-1.748a1.189,1.189,0,0,0,.192-1.424,11.282,11.282,0,0,1-.641-1.23v-.065a4.965,4.965,0,0,1-.385-1.294,1.161,1.161,0,0,0-1.09-.906h-2.5V12.945H4.682a1.17,1.17,0,0,0,1.155-.971c.128-.453.257-.841.385-1.23v-.065a6.76,6.76,0,0,1,.641-1.165A1.189,1.189,0,0,0,6.671,8.09h0L4.939,6.472,6.414,5.048,8.146,6.8a1.07,1.07,0,0,0,1.411.129,7.29,7.29,0,0,1,1.219-.647,10.984,10.984,0,0,1,1.347-.453,1.166,1.166,0,0,0,.9-1.1h0V2.265h1.988V4.66a1.115,1.115,0,0,0,.962,1.1c.449.129.834.259,1.219.388a11.918,11.918,0,0,1,1.283.647A1.071,1.071,0,0,0,19.884,6.6l1.668-1.683,1.411,1.424L21.231,8.09A1.183,1.183,0,0,0,21.1,9.579a7.4,7.4,0,0,1,.641,1.23v.065a4.325,4.325,0,0,1,.385,1.294,1.161,1.161,0,0,0,1.09.906h2.437l-.064,2.006ZM13.919,9.255h0A4.84,4.84,0,0,0,9.108,14.11a5.036,5.036,0,0,0,1.411,3.43,4.945,4.945,0,0,0,3.4,1.424,4.675,4.675,0,0,0,3.4-1.424,4.76,4.76,0,0,0,1.411-3.43,5.036,5.036,0,0,0-1.411-3.43,4.571,4.571,0,0,0-3.4-1.424ZM16.356,16.5h0a3.386,3.386,0,0,1-4.875,0,3.437,3.437,0,0,1-1.026-2.459,3.184,3.184,0,0,1,1.026-2.395,3.386,3.386,0,0,1,4.875,0,3.29,3.29,0,0,1,1.026,2.395A3.329,3.329,0,0,1,16.356,16.5Z' transform='translate(1579.947 2442)'/%3E%3C/svg%3E",
};
export const menuBotImg=styled.div`
    width:  ${props=> props.theme.mini?'65':'50'}px;
    height:100%;
    background-repeat:no-repeat;
    background-size: 20px 20px;
    background-position: center center;
    background-image: url("${props => (item[props.className])}");
       @media screen and (max-width: 1000px){
            width:50px;
        }
`;
export const menuBotText=styled.div`
        color: ${WHITE};
    font-size: ${props=> props.theme.mini?0:16}px;
        ${p => p.theme.mini&& p.theme.realtime && `
                text-align: center;
                line-height: 13px;
                padding-inline:5px;
                font-size: 13px;`};
        @media screen and (max-width: 1000px){
            font-size:16px;
        }
      
`;
export const EventMenuLang=styled.div`
          opacity:0.2;
    pointer-events:none;
`;
export const EventMenuDef=styled.div`
`;
export const EventMenuForm=styled.div`
    background-color: #FFEB00;
    width:  ${props=>props.theme.mini?'45px':'max-content'};
    margin: 0 auto;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 22px;
    padding:${props=>props.theme.mini?'2px':' 5px 20px'};
    font-size: ${props=>props.theme.mini?'12px':'14px'};
    font-weight: 600;
    cursor: pointer;
    display:flex;
    ${props => props.theme.mini&&'line-height: 10px;'}    
    text-align:center;
    @media screen and (max-width: 1000px){
            font-size:14px;
            padding: 5px 15px;
            width:max-content;
            line-height: 16px;
            
        }
`;
export const  EventMenuFormText= styled.div`

`;
export const  EventMenuFormMore= styled.div`
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8.344' height='6.434' viewBox='0 0 8.344 6.434'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: none; stroke: %23484848; stroke-linecap: round; stroke-width: 2px; %7D %3C/style%3E%3C/defs%3E%3Cpath id='Path_2879' data-name='Path 2879' class='cls-1' d='M233.982,21l2.766,3.434L239.514,21' transform='translate(-232.576 -19.594)'/%3E%3C/svg%3E%0A");
        background-repeat:no-repeat;
        background-size:contain;    
        background-size: 9px 9px;
        width: 20px;
        background-position: left center;
`;
export const  EventMenuOP= styled.div`
    position: absolute;
    left: -40px;
    top: 130px;
    input{
        width: 5px;
        height: 0;
        border: 0;
        position: absolute;
    }
`;
export const  EventMenuOPChild= styled.div`
    width: 30px;
    height: 30px;
    background: #FFEB00;
    border-radius: 50%;
    margin-bottom: 10px;
    cursor: pointer;
`;